import './appDesktop.css';
import { useState, lazy, Suspense } from 'react';

import ProjectAdmin from '../projectAdmin/AppProjectAdmin';
import DocketOpen from './docketOpen/AppDocketOpen';
import AppConverter from './Converter/AppConverter';
import aufaImage from '../../images/logo-aufa_all.png';
import AppCalender from './calender/AppCalender';
import AppTasks from './tasks/AppTasks';
import AppReminder from './reminder/AppReminder';
import HocScreen from './HocScreen';
import AppInvoicesList from './InvoicesList/AppInvoicesList';
import AppAufaSumData from './aufaSumData/AppAufaSumData';
import FilterFlights from './FilterFlights/FilterFlights';
import AppOfficeAndWorker from './officeAndWorker/AppOfficeAndWorker';
import AppFilterDockets from './filterDockets/AppFilterDockets';
import IconsRight from './IconsRight';
import IconsLeft from './IconsLeft';
import AufaFilterDockets from './FilterAufaDockets/AufaFilterDockets';
import DocketsFilter from './DocketsFilter/DocketsFilter';


const DocketList = lazy(() => import('./DocketList/DocketList'));
const AppClock = lazy(() => import('./Clock/AppClock'));


function Desktop() {
    const Admin = sessionStorage.getItem('admin') === 'admin';
    const [numToOpenDocket, setNumToOpenDocket] = useState(0);

    const [dataFromSumAToFilterFlights, setDataFromSumAToFilterFlights] = useState({
        name: "", project: "", flight: true
    });

    const [iconsOpen, setIconsOpen] = useState(
        { projectAdmin: false, invoicesList: false, aufaSumData: false, FilterFlights: false, OfficeANdWorker: false, filterDockets: false, aufaOrders: false }
    );

    return (<>
        <div className='desktop'>

            <IconsRight
                onClick={(value) => setIconsOpen({ ...iconsOpen, [value]: true })}
                openNumDocket={setNumToOpenDocket}
            />

            <div className='logo-aufa'>
                <div>
                    <img src={aufaImage} />
                </div>
            </div>

            <IconsLeft
                admin={Admin}
                onClick={(value) => setIconsOpen({ ...iconsOpen, [value]: true })}
            />

            <div className='dockets-list desktop-continer4'>
                <Suspense fallback={<div>Loading...</div>}>
                    <DocketList setOpenDocket={setNumToOpenDocket} />
                </Suspense>
            </div>

            <div className='desktop-center'>
                <Suspense fallback={<div>Loading...</div>}>
                    <AppClock />
                    <AppConverter />
                </Suspense>
            </div>

            <div className='tasks desktop-continer4'>
                <AppTasks />
            </div>

            <div className='calendar desktop-continer4'>
                <AppCalender />
            </div>

            <div className='reminder desktop-continer4'>
                <AppReminder />
            </div>

            <div className='desktop-bottom'>
                <DocketOpen
                    num={numToOpenDocket}
                    setNum={setNumToOpenDocket}
                />
            </div>

            {iconsOpen.projectAdmin && <ProjectAdmin onClose={() => setIconsOpen({ ...iconsOpen, projectAdmin: false })} />}

            {iconsOpen.invoicesList &&
                <HocScreen
                    Comp={AppInvoicesList}
                    head={"רשימת קבלות"}
                    setClose={() => setIconsOpen({ ...iconsOpen, invoicesList: false })}
                    value={iconsOpen.invoicesList}
                    setValue={() => setIconsOpen({ ...iconsOpen, invoicesList: 'none' })}
                    CompProps={{ openNumDocket: setNumToOpenDocket }}
                />}

            {iconsOpen.aufaSumData &&
                <HocScreen
                    Comp={AppAufaSumData}
                    head={'סה"כ אעופה'}
                    setClose={() => setIconsOpen({ ...iconsOpen, aufaSumData: false })}
                    value={iconsOpen.aufaSumData}
                    setValue={() => setIconsOpen({ ...iconsOpen, aufaSumData: 'none' })}
                    CompProps={{
                        setDataForFilterFlights: (data) => {
                            setDataFromSumAToFilterFlights(data);
                            setIconsOpen({ ...iconsOpen, FilterFlights: true });
                        }
                    }}
                />
            }

            {iconsOpen.FilterFlights &&
                <HocScreen
                    Comp={FilterFlights}
                    head={"רשימת טיסות"}
                    setClose={() => setIconsOpen({ ...iconsOpen, FilterFlights: false })}
                    value={iconsOpen.FilterFlights}
                    setValue={() => setIconsOpen({ ...iconsOpen, FilterFlights: 'none' })}
                    CompProps={{ openNumDocket: setNumToOpenDocket, dataForSumA: dataFromSumAToFilterFlights }}
                />
            }

            {
                iconsOpen.OfficeANdWorker &&
                <HocScreen
                    Comp={AppOfficeAndWorker}
                    head={"ניהול משרדים ועובדים"}
                    setClose={() => setIconsOpen({ ...iconsOpen, OfficeANdWorker: false })}
                    value={iconsOpen.OfficeANdWorker}
                    setValue={() => setIconsOpen({ ...iconsOpen, OfficeANdWorker: 'none' })}
                />
            }

            {/* {
                iconsOpen.filterDockets &&
                <HocScreen
                    head={"חיפוש דוקטים"}
                    Comp={AppFilterDockets}
                    setClose={() => setIconsOpen({ ...iconsOpen, filterDockets: false })}
                    value={iconsOpen.filterDockets}
                    setValue={() => setIconsOpen({ ...iconsOpen, filterDockets: 'none' })}
                    CompProps={{ openNumDocket: setNumToOpenDocket }}
                />
            } */}

{
                iconsOpen.filterDockets &&
                <HocScreen
                    head={"חיפוש דוקטים"}
                    Comp={DocketsFilter}
                    setClose={() => setIconsOpen({ ...iconsOpen, filterDockets: false })}
                    value={iconsOpen.filterDockets}
                    setValue={() => setIconsOpen({ ...iconsOpen, filterDockets: 'none' })}
                    CompProps={{ openNumDocket: setNumToOpenDocket }}
                />
            }

            {
                iconsOpen.aufaOrders &&
                <HocScreen
                    head={"חיפוש הזמנות אעופה"}
                    Comp={AufaFilterDockets}
                    setClose={() => setIconsOpen({ ...iconsOpen, aufaOrders: false })}
                    value={iconsOpen.aufaOrders}
                    setValue={() => setIconsOpen({ ...iconsOpen, aufaOrders: false })}
                    CompProps={{ openNumDocket: setNumToOpenDocket }}
                />
            }

        </div>
    </>)
}


export default Desktop;